import { createContext, useContext, useState, useEffect } from "react";
import { detectLang, t as translate, LANG_LABELS, SUPPORTED_LANGS } from "./i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);

  useEffect(() => {
    localStorage.setItem("travea_lang", lang);
  }, [lang]);

  const setLang = (l) => setLangState(l);

  const t = (key, vars) => translate(lang, key, vars);

  return (
    <LangContext.Provider value={{ lang, setLang, t, LANG_LABELS, SUPPORTED_LANGS }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

// Language selector widget — drop anywhere in a header
export function LangSelector({ style = {} }) {
  const { lang, setLang, LANG_LABELS, SUPPORTED_LANGS } = useLang();
  return (
    <div style={{ display: "flex", gap: 2, background: "#1A1916", border: "1px solid #2A2924", borderRadius: 8, padding: 2, ...style }}>
      {SUPPORTED_LANGS.map(l => (
        <button key={l} onClick={() => setLang(l)}
          style={{ padding: "3px 8px", borderRadius: 6, fontSize: 11, fontWeight: lang === l ? 700 : 400, background: lang === l ? "#C9A96E20" : "none", color: lang === l ? "#C9A96E" : "#5A5450", border: lang === l ? "1px solid #C9A96E40" : "1px solid transparent", cursor: "pointer" }}>
          {LANG_LABELS[l]}
        </button>
      ))}
    </div>
  );
}
